'use-strict';

/*if (typeof String.prototype.matchAll !== 'function') {
  matchAll = require('string.prototype.matchall');
  String.prototype.matchAll = matchAll;
}*/

// Shim matchAll
require('string.prototype.matchall').shim();

// Promise
if (typeof Promise === 'undefined') {
  require('promise/lib/rejection-tracking').enable();
  if (window) {
    window.Promise = require('promise/lib/es6-extensions.js');
  }
}
// Object assign
Object.assign = require('object-assign');
// Array find
require('../polyfills/array-find');
// Array findIndex
require('../polyfills/array-findindex');
// Array some
Array.prototype.some = require('../polyfills/array-some');
// Array fill
Array.prototype.fill = require('../polyfills/array-fill');
// Array every
Array.prototype.every = require('../polyfills/array-every');
